/* global URLSearchParams */
import React from 'react'
import { inject, observer } from 'mobx-react'

import { withRouter, Link } from 'react-router-dom'
import { Alert, FormGroup, FormFeedback, Input, Button, Row, Col, Label } from 'reactstrap'
import { Form, Field } from 'react-final-form'
import { FORM_ERROR } from 'final-form'
import { DIGITS, UPPER, LOWER, PUNCT } from 'suredone-common'
import { Loading } from '../../components'
import { AuthPage } from './AuthPage'

import './Reset.css'

const debug = require('debug')('sd:ForgotPassword2')

export default inject('stores')(withRouter(observer(
  class ForgotPassword1 extends React.Component {
    initialCode () {
      return (new URLSearchParams(this.props.location.search)).get('code')
    }

    render () {
      return (
        <AuthPage
          headerSubtitle={
            <p className='d-flex justify-content-center align-items-baseline'>
              Back to <Button className='pl-1' color='link' to='/login' tag={Link}>Login</Button>
            </p>
          }
          form={
            <Form
              initialValues={{
                code: this.initialCode()
              }}
              onSubmit={async values => {
                const { code, password } = values
                try {
                  await this.props.stores.auth.resetPassword(code.trim(), password)
                } catch (err) {
                  debug({ err })
                  return { [FORM_ERROR]: err.message }
                }
                this.props.history.push('/login?password-reset=true')
              }}
              render={state => {
                debug('FinalForm.render(state)', state)
                const { handleSubmit, submitError, hasValidationErrors, submitting, pristine, values } = state
                return (
                  <form className='auth-form' onSubmit={handleSubmit} style={{ maxWidth: '460px' }}>
                    {this.initialCode()
                      ? null
                      : <Alert color='success'>Please check your email for your confirmation code and enter it here.</Alert>}

                    <FormGroup>
                      <div className='form-label-group'>
                        <Field
                          name='code'
                          validate={code => code ? undefined : 'Password reset code is required'}
                        >
                          {({ input, meta }) => (
                            <>
                              <Input
                                {...input}
                                autoFocus
                                type='text'
                                id='code'
                                valid={meta.valid}
                                placeholder='Password reset code'
                                invalid={meta.error && meta.touched && !meta.pristine}
                              />
                              <Label for='code'>Password reset code</Label>
                              {meta.error && meta.touched && !meta.pristine && <FormFeedback>{meta.error}</FormFeedback>}
                            </>
                          )}
                        </Field>
                      </div>
                    </FormGroup>

                    <Row>
                      <Col xs={12} sm={6}>
                        <FormGroup>
                          <div className='form-label-group'>
                            <Field
                              name='password'
                              validate={password => {
                                if (!password) return 'Password is required'
                                if (!DIGITS.test(password)) return 'Password must contain one or more digits.'
                                if (!UPPER.test(password)) return 'Password must contain one or more uppercase letters.'
                                if (!LOWER.test(password)) return 'Password must contain one or more lowercase letters.'
                                if (!PUNCT.test(password)) return 'Password must contain one or more punctuation characters.'
                              }}
                            >
                              {({ input, meta }) => (
                                <>
                                  <Input
                                    {...input}
                                    type='password'
                                    id='password'
                                    valid={meta.valid}
                                    placeholder='New password'
                                    invalid={meta.error && meta.touched && !meta.pristine}
                                  />
                                  <Label for='password'>New password</Label>
                                  {meta.error && meta.touched && !meta.pristine && <FormFeedback>{meta.error}</FormFeedback>}
                                </>
                              )}
                            </Field>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={12} sm={6}>
                        <FormGroup>
                          <div className='form-label-group'>
                            <Field
                              name='password2'
                              validate={password2 => {
                                if (!password2) return 'Password confirmation is required'
                                if (values.password !== password2) return 'Passwords don\'t match'
                              }}
                            >
                              {({ input, meta }) => (
                                <>
                                  <Input
                                    {...input}
                                    type='password'
                                    id='password2'
                                    placeholder='Confirm new password'
                                    valid={meta.valid}
                                    invalid={meta.error && meta.touched && !meta.pristine}
                                  />
                                  <Label for='password2'>Confirm new password</Label>
                                  {meta.error && meta.touched && !meta.pristine && <FormFeedback>{meta.error}</FormFeedback>}
                                </>
                              )}
                            </Field>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup>
                      {submitError
                        ? (
                          <Alert color='danger'>
                            {submitError}
                          </Alert>)
                        : null}
                      {submitting ? <Loading /> : null}
                      <Button type='submit' color='primary' disabled={submitting || pristine || hasValidationErrors} block>
                        Change Password
                      </Button>
                      <Button
                        color='link'
                        to='/login'
                        className='pl-0 mt-2'
                        onClick={e => {
                          e.preventDefault()
                          this.props.stores.auth.logOut()
                        }}
                        tag={Link}
                      >
                        Cancel Password Reset
                      </Button>
                    </FormGroup>
                  </form>
                )
              }}
            />
          }

        />
      )
    }
  }
)))

debug('loaded')
